/* eslint-disable class-methods-use-this */
/* eslint-disable lines-between-class-members */
/* eslint-disable no-empty-function */
/* eslint-disable no-useless-constructor */

// Mock for instantsearch.js/es/lib/chat/index
// The chat feature is not used in v2-consumer and causes compatibility issues
// This mock prevents the chat module from being bundled and provides a stub

// Export a Chat class that can be instantiated but does nothing
// eslint-disable-next-line max-classes-per-file
class ChatMock {
  constructor() {}
  dispose() {}
}

// Export empty types that react-instantsearch expects
class RecommendToolType {}
class SearchIndexToolType {}

// Export as named exports and default export
export { ChatMock as Chat, RecommendToolType, SearchIndexToolType };
export default ChatMock;
